import styled from "styled-components";

export const ContainerData = styled.div`
  border: 1px solid #f9ae17;
  padding: 10px 15px;
  border-radius: 10px;
`;

export const LabelData = styled.span`
  font-weight: bold;
  color: #203b34;
  margin-right: 10px;
`;

export const ButtonAction = styled.button`
  margin-right: 2px;
  color: #fff;
  font-size: 1rem;
  border: 0px;
  background: #203b34;
  width: max-content;

  &:hover {
    background: #ff9800;
    font-size: 1rem;
  }
`;

export const Icon = styled.i`
  margin-right: 10px;
`;

export const Option = styled.li`
  padding: 10px;
`;

export const ListOptions = styled.ul`
  background: #203b34;
`;

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;

export const ContainerProdCons = styled.div`
  border: 1px solid #203b34;
  padding: 10px 15px;
  min-height: 250px;
`;

export const TitleProdCons = styled.div`
  font-size: 1rem;
  margin-bottom: 5px;
  color: #f9ae17;
  font-weight: 600;
`;

export const HeadTable = styled.div`
  font-size: 0.875rem;
  font-weight: 700;
`;

export const RowTable = styled.div`
  font-size: 0.875rem;
`;
